import ComboRecentOrFavOrderItem from "./ComboRecentOrFavOrderItem";


// Full Menu List Componenet
export default class ComboRecentOrderItemsCard extends React.Component {
    constructor(props) {
        super(props);

        this.state={
            isMadeFavorite: false,
            isRecentOrFaveOrderMode: true,
            drawerIsClosed: true,
            newFaveValue: "",
            
        }

        this.favorite = "/images/2/icons/like-heart.png";
        this.unFavorite = "/images/2/icons/unfav-heart.png";
        this.toggleFaveStatus = this.toggleFaveStatus.bind(this);
        this.showRecentOrderCard = this.showRecentOrderCard.bind(this);
        this.sendNewFaveData = this.sendNewFaveData.bind(this);
        this.getNewFaveValue = this.getNewFaveValue.bind(this);
        this.hideCardImagesAndTitle = this.hideCardImagesAndTitle.bind(this);
        this.showCardImagesAndTitle = this.showCardImagesAndTitle.bind(this);
       
    }
    componentDidMount() {

    }

    getNewFaveValue(e){
        this.setState({newFaveValue: e.target.value})
    }

    toggleFaveStatus(e){
        this.setState({isMadeFavorite : !this.state.isMadeFavorite})

        if(!this.state.isMadeFavorite){
            this.setState({isRecentOrFaveOrderMode : false})
        }
    }
    showRecentOrderCard(e) {
        this.setState({isRecentOrFaveOrderMode : true, isMadeFavorite: false})
    }
    showRecentOrderCardAfterSave(e) {
        this.setState({ isRecentOrFaveOrderMode: true, isMadeFavorite: true })
    }
    
    sendNewFaveData(e) {
        var localThis = this;
      //var request = {};
      //request.basketid = this.props.recentOrder.basket.id
      //request.restaurantid = "";
      //  request.orderid = this.state.newFaveValue
        var verificationToken = $("div.forgery-token").find('input[name=__RequestVerificationToken]').val();
        var request = {
            "basketid": this.props.recentOrder.basket.id,
            "restaurantid":"",
            "orderid": this.state.newFaveValue,
            "__RequestVerificationToken": verificationToken
        };
      $.ajax({
          url: '/api/sitecore/Menu2/SaveOrderAsFavorite',
          type: 'POST',
          data: request,
      }).done(function (data) {
       
          if (data && data.status) {
              if (!data.fave.products)
                  data.fave.products = localThis.props.recentOrder.basket.products;
              localThis.showRecentOrderCardAfterSave();
              localThis.props.sendNewFaveData(data.fave);
              console.log(data.fave)
          }
          else {
              if (data.alert != null) {
                  if (DE.AlertMessageBar) {
                      DE.AlertMessageBar.handleAlert(data.alert);
                  }
              }
          }
      });

        /* IHWEB-5290 Story Implementation */
        $('.docked-right-modal .modal-body.delivery #alert-message-container-fav').remove();
        setTimeout(function () {
            if (($('#myAccount .c-alert-message-container').children().length === 0) || ($('#recordnone .c-alert-message-container').children().length === 0)) {
                $('.modal.modal_outer.docked-right-modal').removeClass('alertmessageshow');
            }
            else {
                $('.modal.modal_outer.docked-right-modal').addClass('alertmessageshow');
            }
            
            $('#alert-message-container').clone().prependTo($('.docked-right-modal .modal-body.delivery'));
            $('.docked-right-modal .modal-body.delivery .c-alert-message-container').attr('id', 'alert-message-container-fav');
            $('div#alert-message-container.c-alert-message-container .c-alert__wrapper .c-alert__close').trigger('click');
        }, 3000);
    }

    hideCardImagesAndTitle(){
       this.setState({drawerIsClosed : true})
    }
    showCardImagesAndTitle(){
        this.setState({ drawerIsClosed: false })
        
    }
   
    
    render() {
        return (
            <div>
                
          {
            (this.state.isRecentOrFaveOrderMode)?
                              
                (<div id={this.props.recentOrder.basket.id}  className="fav-meal-container fixed-martop text-center w-100">
                                    <div className="iHop-Gotham fav-h4 h4">{this.props.recentOrder.orderName}</div>
                                    <button data-toggle="modal" data-target="" className="heart-button" onClick={this.toggleFaveStatus}>
                                        <img src={this.state.isMadeFavorite? this.favorite :  this.unFavorite} className="img-fluid like-heart" alt="favorite meals" />
                                    </button>
                                    
                                    <div className="pre-content">
                                       
                                        <div className="pre-wrapper">
                                        {this.state.drawerIsClosed &&
                                            <div>
                                       
                                            <ul className="img-list-pre" role="list">
                                                { this.props.recentOrder.basket.products.map(product => {
                                                     return (
                                                          <li className="img-list-item-pre">
                                                    <img src={product.image} className="img-fluid" alt={product.imagealt} />
                                                     </li>
                                                     );
                                                 })
                                                }                                                 
                                            </ul>
                                            <p className="pre-text iHop-Gotham">
                                                  {this.props.recentOrder.basket.products.map(product => { return product.name }).join(", ").trim()}                                                  
                                            </p>
                                           
                                           </div>
                                           }
                                        </div>
                                        

                                        <div className="exp-container text-left hide-sec">
                                        {
                                          this.props.recentOrder.basket.products.map(menuData => {
                                              return (
                                                  <ComboRecentOrFavOrderItem 
                                                    title = {menuData.name}
                                                    img = {menuData.image}
                                                    calories={menuData.basecalories}
                                                    itemCount={menuData.quantity}
                                                    description = {menuData.choices.map(choice => { return choice.name  }).join(", ").trim() }
                                               />
                                              );
                                            })
                                        }   
                                            <div>
                                            <p className="order-pick-details">{this.props.recentOrder.completedOn}</p>
                                            <p className="order-address">{this.props.recentOrder.vendorName}<br/> {this.props.recentOrder.vendorAddress}<br/> {this.props.recentOrder.vendorlocationInfo}</p>
                                            <div className="total-container recentorder-sec">
                                            <div className="table-con">
                                                <table className="table price-data" >
                                                    <tr className="item-name iHop-Gotham" role="presentation">
                                                        <td tabIndex="0" Title="Subtotal">Subtotal</td>
                                                        <td className="text-right" tabIndex="0" aria-label={"$" + this.props.recentOrder.basket.subtotal.toFixed(2)} >${this.props.recentOrder.basket.subtotal.toFixed(2)}</td>
                                                        </tr>
                                                        <tr className="item-name iHop-Gotham">
                                                        <td tabIndex="0" Title="Taxes">Taxes</td>
                                                        <td className="text-right" tabIndex="0" title={"$" + this.props.recentOrder.basket.salestax.toFixed(2)}>${this.props.recentOrder.basket.salestax.toFixed(2)}</td>
                                                        </tr>
                                                        {this.props.recentOrder.basket.thirdPartyDeliveryFee > 0 &&
                                                            <tr >
                                                        <td role="presentation">
                                                            <span tabIndex="0" aria-label="Third-Party Delivery Fees">Third-Party Delivery Fees</span>
                                                            <i className="fas fa-info-circle taxes-icon" aria-hidden="true" tabIndex="0" aria-labelledby="delivery-Fee-tooltip"></i>
                                                            <span className="tooltip-container" role="tooltip" aria-expanded="true" id="delivery-Fee-tooltip">
                                                                        {this.props.recentOrder.basket.DeliveryCharge > 0 &&
                                                                            <span className="tooltip-h3">
                                                                    <span className="tip-heading text-left">
                                                                        <span className="tip-head-txt">{this.props.recentOrderData.DeliveryChargeText}</span>
                                                                                </span>
                                                                    <span className="tip-amount text-right">
                                                                        <span className="tip-amount-txt">${this.props.recentOrder.basket.DeliveryCharge.toFixed(2)}</span>
                                                                                </span>
                                                                            </span>
                                                                        }
                                                                        {this.props.recentOrder.basket.ServiceFee > 0 &&
                                                                            <span className="tooltip-h3">
                                                                                <span className="tip-heading text-left">
                                                                        <span className="tip-head-txt">{this.props.recentOrderData.ServiceChargeText}</span>
                                                                                </span>
                                                                                <span className="tip-amount text-right">
                                                                                    <span className="tip-amount-txt">${this.props.recentOrder.basket.ServiceFee.toFixed(2)}</span>
                                                                                </span>
                                                                            </span>
                                                                        }
                                                                        {this.props.recentOrder.basket.CADeliverySurcharge > 0 &&
                                                                            <span className="tooltip-h3">
                                                                                <span className="tip-heading text-left">
                                                                        <span className="tip-head-txt">{this.props.recentOrderData.CAChargeText}</span>
                                                                                </span>
                                                                                <span className="tip-amount text-right">
                                                                                    <span className="tip-amount-txt">${this.props.recentOrder.basket.CADeliverySurcharge.toFixed(2)}</span>
                                                                                </span>
                                                                            </span>
                                                                        }
                                                                        {this.props.recentOrder.basket.CODeliveryFee!=null &&
                                                                            <span className="tooltip-h3">
                                                                                <span className="tip-heading text-left">
                                                                        <span className="tip-head-txt">{this.props.recentOrderData.COChargeText}</span>
                                                                                </span>
                                                                                <span className="tip-amount text-right">
                                                                                    <span className="tip-amount-txt">${this.props.recentOrder.basket.CODeliveryFee.amount.toFixed(2)}</span>
                                                                                </span>
                                                                            </span>
                                                                        }
                                                                    </span>
                                                                </td>
                                                        <td className="text-right" role="presentation" tabIndex="0" title={"$" + this.props.recentOrder.basket.thirdPartyDeliveryFee.toFixed(2)}>
                                                                    ${this.props.recentOrder.basket.thirdPartyDeliveryFee.toFixed(2)}
                                                                </td>
                                                            </tr>
                                                        }
                                                        
                                                        {this.props.recentOrder.basket.BagFee > 0 &&
                                                        <tr className="item-name iHop-Gotham">
                                                            <td tabIndex="0" title="Bag Fee">Bag Fee</td>
                                                        <td className="text-right" tabIndex="0" aria-label={"$" + this.props.recentOrder.basket.BagFee.toFixed(2)}>${this.props.recentOrder.basket.BagFee.toFixed(2)}</td>
                                                            </tr>
                                                        }
                                                        {this.props.recentOrder.basket.tip > 0 &&
                                                            <tr className="item-name iHop-Gotham">
                                                        <td tabIndex="0" title="Tip">Tip</td>
                                                        <td className="text-right" tabIndex="0" aria-label={"$" + this.props.recentOrder.basket.tip.toFixed(2)}>${this.props.recentOrder.basket.tip.toFixed(2)}</td>
                                                            </tr>
                                                        }
                                                        <tr className="item-total iHop-Gotham">
                                                        <td tabIndex="0" title="Order Total">Order Total</td>
                                                        <td className="text-right" tabIndex="0" aria-label={"$" + this.props.recentOrder.basket.total.toFixed(2)}>${this.props.recentOrder.basket.total.toFixed(2)}</td>
                                                        </tr>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    
                                </div>
                                <a href="javascript:;" className="closed-acc" role="link" tabIndex="0"><span onClick={this.showCardImagesAndTitle} id={this.props.recentOrder.basket.id} className="see-full-txt">{this.props.recentOrderData.SeeFullDetailsText}</span><span onClick={this.hideCardImagesAndTitle} id={this.props.recentOrder.basket.id} className="close-txt hide-link">{this.props.recentOrderData.CloseText}</span> <span id={this.props.recentOrder.basket.id} className="down-arrow"></span></a>
                                <a href="#" className="js-order-to-basket order-btn" role="button" tabIndex="0" data-value={this.props.recentOrder.basket.id}><span className="order-txt" >{this.props.recentOrderData.ReorderButtonText}</span></a>
                                    </div>
                                </div>)
                                :
                        
                                                    (<div>
<div className="fav-meal-container text-center w-100 margin-bot13 rel-pos fav-martop">
<div className="heart-image-con">
    <img src="/images/2/icons/heart-filled-big.png" alt="favorite meals heart filled" className="img-fluid big-heart-image"/>
</div>
<button type="button" className="save-sec-closebtn" aria-label="Close">
    <img src="/images/2/icons/ihop-modal-close.png" onClick={this.showRecentOrderCard} className="img-fluid" alt={this.props.recentOrderData.CloseText} />
</button>
<p className="order-fav-txt">{this.props.recentOrderData.SaveAsFavoriteTitle}</p>
<p className="order-name-txt">{this.props.recentOrderData.SaveAsFavoriteSubTitle}</p>


<div className="search-sec">
    <div className="form-group has-search m-0">
        <input type="text" onChange={this.getNewFaveValue} maxLength="24" className="form-control" placeholder={this.props.recentOrderData.SaveAsFavoritePlaceholderText} aria-label="Save favorite meal" />
    </div>
</div>

<div className="select-box-sec">
    <div className="row justify-content-center">
        <div className="col-12 col-sm-9">
            <a className="btn btn-lg w-100 savered-btn" onClick={this.sendNewFaveData} href="#" role="button">{this.props.recentOrderData.SaveAsSaveButtonText}</a>
        </div>
    </div>
</div>
</div>
</div>)
}            
</div>
        );
                                            }
                                            }
